<template>
  <div class="ab-server warp">
    <div class="block-title" data-aos="fade">提供全方位运营服务</div>
    <div class="block-subtitle" data-aos="fade" data-aos-delay="100">
      有效降低企业各项运营成本
    </div>
    <div class="server-list" id="server-list">
      <!--<a-affix :offset-top="top" style="z-index: 999">-->
      <div class="server-price" id="server-price">
        <a-row>
          <a-col :span="4">
            <div class="server-pro">
              <span class="fontsize20">服务内容</span>
            </div>
          </a-col>
          <a-col :span="5">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize22">营销版</div>
              <div class="item-price fontsize24">
                <span>¥询盘服务 19888(年)套餐 </span>
              </div>
              <!-- <div> -->
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
              <!-- </div> -->
            </div>
          </a-col>
          <a-col :span="5">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize22">专业版</div>
              <div class="item-price fontsize24">
                <span>¥询盘服务 29888(年)套餐 </span>
              </div>
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
            </div>
          </a-col>
          <a-col :span="5">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize26">铂金版 <em>推荐</em></div>
              <div class="item-price fontsize28">
                <span>¥询盘服务 39888(年)套餐 </span>
              </div>
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
            </div>
          </a-col>

          <a-col :span="5">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize22">尊贵版</div>
              <div class="item-price fontsize24">
                <span>¥询盘服务 69888(年)套餐 </span>
              </div>
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <!--</a-affix>-->
      <div class="server-desc">
        <div class="server-desc-item">
          <div class="item-desc-name flex-row ad-item-height">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p><em></em> 满足企业不同发展阶段业务需求</p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                用户权益
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">
                <span> <strong> 按品类定制保底询盘量 </strong></span>
                保底最多200个协商确定
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">
                <span><strong> 按品类定制保底询盘量</strong></span>
                保底最多300个协商确定
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">
                <span><strong> 按品类定制保底询盘量</strong></span>
                保底最多400个协商确定
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">
                <span><strong> 按品类定制保底询盘量</strong></span>
                保底最多700个协商确定
              </div>
            </a-col>
          </div>
        </div>

        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p>
                      <em></em>
                      基于外贸大数据的专业化知识体系和专业的营销人才提供完善营销推广解决方案服务
                    </p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                营销决策
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
          </div>
          <a-row class="item-row">
            <a-col :span="4">需求沟通确认</a-col>
            <a-col :span="5"> 免费 </a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">行业品类研究</a-col>
            <a-col :span="5"> 免费 </a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销方案确认</a-col>
            <a-col :span="5"> 免费 </a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p>
                      <em></em>
                      聚焦营销推广构建的营销资料处理团队，为用户解决营销素材处理和内容优化
                    </p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                营销资料
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
          </div>
          <a-row class="item-row">
            <a-col :span="4">营销资料图片</a-col>
            <a-col :span="5">20</a-col>
            <a-col :span="5">50</a-col>
            <a-col :span="5">80</a-col>
            <a-col :span="5">150</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销资料产品</a-col>
            <a-col :span="5">20</a-col>
            <a-col :span="5">50</a-col>
            <a-col :span="5">80</a-col>
            <a-col :span="5">150</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销资料新闻</a-col>
            <a-col :span="5">20</a-col>
            <a-col :span="5">50</a-col>
            <a-col :span="5">80</a-col>
            <a-col :span="5">150</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销资料编写</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p>
                      <em></em>
                      基于全球主流搜索引擎打造，专业SEO人才和自动化建站系统结合,为用户高效解决品牌官网和营销站群的建设、维护优化工作
                    </p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                搜索引擎
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
          </div>
          <a-row class="item-row">
            <a-col :span="4">专属网页模板订制</a-col>
            <a-col :span="5">0</a-col>
            <a-col :span="5">0</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">1</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">品牌官网域名</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">1</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">品牌官网英语站</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">1</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">品牌官网其它站</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">3</a-col>
            <a-col :span="5">6</a-col>
            <a-col :span="5">10</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销站群域名</a-col>
            <a-col :span="5">10</a-col>
            <a-col :span="5">30</a-col>
            <a-col :span="5">50</a-col>
            <a-col :span="5">100</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销站群网站</a-col>
            <a-col :span="5">10</a-col>
            <a-col :span="5">30</a-col>
            <a-col :span="5">50</a-col>
            <a-col :span="5">100</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">站点管理维护</a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">SEO优化服务</a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">SEM广告投放</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
          </a-row>
        </div>

        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p>
                      <em></em>
                      基于全球主流社交媒体，专业化社媒营销推广人才和自动化社媒营销推广系统，为用户品牌塑造和产品推广提供便捷高效可靠的社媒推广服务
                    </p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                社媒推广
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
          </div>
          <a-row class="item-row">
            <a-col :span="4">独享社媒账号</a-col>
            <a-col :span="5">0</a-col>
            <a-col :span="5">1</a-col>
            <a-col :span="5">2</a-col>
            <a-col :span="5">3</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">社媒推广订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">自营发贴数量</a-col>
            <a-col :span="5">120</a-col>
            <a-col :span="5">240</a-col>
            <a-col :span="5">480</a-col>
            <a-col :span="5">1200</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">代理推广权限</a-col>
            <a-col :span="5">-</a-col>
            <a-col :span="5">-</a-col>
            <a-col :span="5">-</a-col>
            <a-col :span="5">-</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">代理发贴数量</a-col>
            <a-col :span="5">240</a-col>
            <a-col :span="5">480</a-col>
            <a-col :span="5">960</a-col>
            <a-col :span="5">2400</a-col>
          </a-row>
          <a-row class="item-row server-desc-opacity">
            <a-col :span="4">社媒监控服务</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
            <a-col :span="5">付费订制</a-col>
          </a-row>
        </div>
        <div class="server-desc-item server-desc-opacity">
          <div class="item-desc-name flex-row">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p>
                      <em></em>
                      聚焦行业，以外贸资讯、外贸知识、展示与沟通、帮助与问答等服务为基础为用户提供一个可靠有效综合类服务平台
                    </p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                行业平台
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
          </div>
          <a-row class="item-row">
            <a-col :span="4">基础信息展示</a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">行业专属展示</a-col>
            <a-col :span="5">-</a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">平台专属展示</a-col>
            <a-col :span="5">-</a-col>
            <a-col :span="5">-</a-col>
            <a-col :span="5">-</a-col>
            <a-col :span="5"><i class="iconfont icon-duidui"></i></a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p>
                      <em></em> 基于全球企业大数据，
                      通过询盘特征为用户进行询盘处理和信息完善，提高询盘质量和工作效率
                    </p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                询盘处理
              </div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
            <a-col :span="5">
              <div class="fontsize16">服务指标</div>
            </a-col>
          </div>
          <a-row class="item-row">
            <a-col :span="4">专属在线客服</a-col>
            <a-col :span="5"> 免费 </a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">垃圾数据过滤</a-col>
            <a-col :span="5"> 免费 </a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">客户信息挖掘</a-col>
            <a-col :span="5"> 免费 </a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
            <a-col :span="5">免费</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p><em></em> 评估产品是否适合自身企业的需要</p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                产品分析
              </div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
          </div>
          <a-row class="item-row">
            <a-col :span="4">产品说明</a-col>
            <a-col :span="20"
              ><i>
                基于专业团队打造的智能化全渠道营销推广系统，为用户提供可靠的营销推广服务；此产品通过询盘保底的方式保障用户权益，支持按询盘价格订制服务套餐，直到服务达标为止；</i
              >让用户的每一分钱都花得物有所值；服务过程真实可见，买得放心，用得安心；
            </a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">产品特点</a-col>
            <a-col :span="20">
              <i>
                专业化服务、全渠道营销、询盘量定制、有询盘保底、效果有保障、服务有保障</i
              >
              <i>询盘上架后无需购买，都专属于用户</i>
              专注于询盘保量，尽力为用户获取更多高质量询盘
            </a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">产品优势</a-col>
            <a-col :span="20"
              ><i
                >很高性价比：通过服务保障，按用户需求定制询盘量，提供询盘保底为用户提供稳定的营销获客服务</i
              >
              <i
                >低尝试成本：平台提供服务保障和效果保障，为用户需求保底，尝试风险很低</i
              >
              <i>高效能： 专业营销人员、专业营销体系、专业技术团队</i>
              <i>一站式：省人力，省成本、省时间、省操心</i>
              有保障：
              服务有保障，过程真实可见；效果有保障，全渠道专业营销，询盘量有保底
            </a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">适用场景</a-col>
            <a-col :span="20"
              ><i
                >服务指标影响服务效果，服务过程涉及大量人工成本已购买获客产品，需要再增加客户量</i
              >
              <i>资金不充裕，想做全渠道营销推广</i>
              <i>营销效果不好，想尝试一个新渠道</i>
              <i>希望营销效果有保障，降低营销成本</i>
              <i>没有时间操心营销推广，减少营销成本</i>
              <i>想降低公司整体营销成本，获得更多客户</i>
              <i>想让自己团队更聚焦，提升营销推广效能</i>
              询盘质量不好，想要询盘质量有保障和系统资源成本，平台需要投入大量的人工营销推广成本获得询盘</a-col
            >
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <a-col :span="4">
              <div class="desc-name fontsize20">
                <a-popover title="" placement="top" arrow-point-at-center>
                  <template slot="content">
                    <p><em></em> 可靠保障免除后顾之优</p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
                其它说明
              </div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
            <a-col :span="4">
              <div class="fontsize16"></div>
            </a-col>
          </div>
          <a-row class="item-row">
            <a-col :span="4">决策依据</a-col>
            <a-col :span="20"
              ><i>
                1、降低企业在营销推广投入的人力成本，2、降低购买市场其它同类产品的支出成本，3、降低市场其它产品营销效果不确定带来的风险</i
              >4、高性价比产品，国内超高性价比，5、人工沟通过滤询盘，提高询盘有效率7、询盘有保底，可靠性更高
            </a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">续费说明</a-col>
            <a-col :span="20">
              服务期限满一年且保底询盘达标后，可按购买原价续费</a-col
            >
          </a-row>

          <a-row class="item-row">
            <a-col :span="4">服务终止</a-col>
            <a-col :span="20">
              <i> 1、服务期限满一年且保底询盘达标后无续费，自动终止服务；</i
              >2、终止服务后，营销资料及官网静态站归用户所有，其它资源可按需付费购买；</a-col
            >
          </a-row>
        </div>
      </div>
    </div>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import Abbutton from "@/components/Abbutton.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import { usePageTracker } from "@/utils/pageTracker";
export default {
  data() {
    return {
      navBarFixed: false,
      abHideElement: false,
      top: 57,
      visible: false,
    };
  },

  mounted() {
    // 事件监听滚动条
    // window.addEventListener('scroll', this.watchScroll);
  },

  destroyed() {
    // 移除事件监听
    // window.removeEventListener('scroll', this.watchScroll);
  },

  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
  components: {
    Abbutton,
    inquiryModalVue,
  },
};
</script>

<style lang="sass" scoped>
.ab-server .server-desc .server-desc-item .item-desc-name.ad-item-height{
height:auto;
margin-bottom: 0px;background:#fff;
margin-top:0.2rem;

.ant-col-5 .fontsize16{
  span{
  display: block;
  padding-top:6px;
}
    line-height:24px;    font-family: Alibaba-PuHuiTi-R;
}
}
.server-desc-opacity{
  opacity: .4
}
 .ant-popover-inner-content{
   p{
     width: 280px;
     display: flex;
    em{
    width: 8px;
    height: 8px;
    background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
    display: inline-block;
    border-radius: 50%;
    position: relative;
    top: 8px;
    margin-right: 8px;
    }
    font-size: 16px;
  }
}

  .ab-fix-nav {
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .ab-hide {
    display: none;
  }

.ab-server{
  background-color: rgba(255, 255, 255, 1);
  padding-top: 81px;
  .block-title{
    height: 55px;
    font-size: 40px;
    font-family: AlibabaPuHuiTiB;
    line-height: 55px;
    text-align: center;
  }

  .block-subtitle{
    text-align: center;
    padding-top: 10px;
    height: 27px;
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    padding-bottom:30px;
    line-height: 27px;
    opacity: 0.8;
  }

  .server-list{
    margin-top: 38px;
    border: 1px solid #D6EAFF;
  }
.ant-affix .server-price{margin-top:23px;}
  .server-price{
  .ant-row{
     background: #fff;
    height: 203px;
  }

    .server-pro{
      height: 200px;
      background: rgba(214, 234, 255, 1);
      text-align: center;
      span{
        font-family: AlibabaPuHuiTiM;
        font-weight: normal;
        color: #333646;
        line-height: 200px;
      }
    }
      .price-val{
        max-width: 100%;
        height: 200px;
        background: #F4F9FF;
        text-align: center;
        padding-top: 25px;
        padding-bottom: 30px;
         border-left: 3px solid #fff;

        .item-name{
          font-family: AlibabaPuHuiTiM;
          color: #2B68FF;
          line-height: 35px;
          em{
            width: 40px;
            display:inline-block;
            line-height: 20px;
            font-family: 'Alibaba-PuHuiTi-R';
            background: #50E07B;
                top: -3px;
                position: relative;
            font-size:12px;
            text-align:center;
            color:#fff;
            border-radius: 4px;
          }
        }
        .item-price{
          font-family: AlibabaPuHuiTiM;
          font-weight: normal;
          color: #FF6531;
          line-height: 38px;
          span{
            font-size:16px;
          }
        }

        .item-try-btn{
            .ab-btn{
              width:120px;
              max-width:100%;
              height:46px;
              line-height:46px;
              a{
                font-size:18px;
              }
            }
        }
      }
  }

  .server-desc{
    .item-desc-name{
     /*position: sticky;*/
     /*top:280px;z-index: 1;*/
    }
    paadding: 15px 0 0 78px;
    .server-desc-item{
padding-bottom:10px;
      .item-desc-name{
        .ant-col-5 .fontsize16{
          color:rgba(51, 54, 70, .7);
          line-height:60px;
          text-align:center;
          border-left:3px solid #fff;
        }
        i{
        &:hover{
            color:#fff;
            background:#2B68FF;
            border-radius:50%;
          }
          cursor: pointer;
          margin-left: 78px;
        }

        height: 60px;
        margin-bottom:10px;
        background: #F4F9FF;

        .desc-icon{
          width: 33px;
          position: relative;
          & img{
               position: absolute;
               width:25px;
               top: 17px;
          }
        }
        .desc-name{
          font-family: AlibabaPuHuiTiM;
          font-weight: normal;
          color: #333646;
          line-height: 60px;
        }
      }

      .item-row{
        &:hover .ant-col{
          color:#2B68FF
        }
        .ant-col-20{
          i{
            display: block;
          }
        }
        .ant-col-4{
          display: flex;
          flex-wrap: wrap;
          align-content: center;
        }
        .ant-col-5{

          i.icon-duidui,i.icon-chacha{
             font-size:22px;
      position: relative;
      top: 3px;color: rgb(80, 224, 123);
          }
            i.icon-chacha{
      color:#FA5151
    }
        }
        overflow-wrap: break-word;
        color: rgba(51, 54, 70, 1);
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R;
        text-align: left;
        line-height: 30px;
        padding: 7px 0px;
        display: flex;

        div:nth-child(1){
          padding-left: 78px;
        }

        div:nth-child(n + 2){
          text-align: center;
        }
      }
      .item-remark{
        background: #F4F9FF;
        padding-bottom:30px;
        margin-top:-10px;

        .block-remark{
          overflow-wrap: break-word;
          color: rgba(51, 54, 70, 1);
          font-size: 16px;
          font-family: Alibaba-PuHuiTi-R;
          text-align: left;
          padding: 10px 0px;
          padding-right:56px;
          div:nth-child(1){
            padding-left: 88px;
          }
        }
      }
    }
  }
}
</style>
